import { createAction, props } from '@ngrx/store';
import { LookupValue } from 'src/app/models/lookup.model';
import { BulkResponse, ProductFamily, SBU, SealingElement, SealingElementEquipmentType, SealingElementPluggingHead, SellableStatus, SubSBU } from 'src/app/models/sealing-element.model';
import { Loaders, SealingElementFilter } from '../fromSealingElement.barrel';

const prefix = '[SealingElement]';

export const removeLoader = createAction(`${prefix} remove loader`, props<{ loader: Loaders }>());

// the load to return the results of the query with the filter inputs
export const loadSealingElements = createAction(`${prefix} load sealing elements`, props<{ skip: number, take: number }>());
export const loadSealingElementsSuccess = createAction(`${prefix} Load SealingElement Success`, props<{ data: BulkResponse<SealingElement> }>());
export const loadSealingElementsFail = createAction(`${prefix} Load SealingElement Failure`, props<{ error: any }>());

// a way to trigger a load for all the lookup values at once
export const loadSealingElementsLookups = createAction(`${prefix} load lookups`);

// this is the update to the filter which will trigger loadSealingElements
export const updateSealingElementFilter = createAction(`${prefix} update sealing element filter`, props<{ obj: Partial<SealingElementFilter> }>());

// this will toggle the sellable code selection on the filter
export const toggleSellableCode = createAction(`${prefix} toggle sellable code`, props<{ code: string }>());

// this will select the indicated sealing element
export const toggleSelectedProduct = createAction(`${prefix} toggle selected product`, props<{ partNumber: string }>());
export const toggleNextSelectedProduct = createAction(`${prefix} toggle next selected product`);
export const togglePreviousSelectedProduct = createAction(`${prefix} toggle previous selected product`);

// lookups
export const loadPipeSizes = createAction(`${prefix} load pipe sizes`);
export const loadPipeSizesSuccess = createAction(`${prefix} load pipe sizes success`, props<{ data: LookupValue[] }>());
export const loadPipeSizesFail = createAction(`${prefix} load pipe sizes fail`, props<{ error: any }>());

// lookups
export const loadMaterials = createAction(`${prefix} load materials`);
export const loadMaterialsSuccess = createAction(`${prefix} load materials success`, props<{ materials: LookupValue[] }>());
export const loadMaterialsFail = createAction(`${prefix} load materials fail`, props<{ error: any }>());

// lookups
export const loadProductFamilies = createAction(`${prefix} load families`);
export const loadProductFamiliesSuccess = createAction(`${prefix} load families success`, props<{ families: ProductFamily[] }>());
export const loadProductFamiliesFail = createAction(`${prefix} load families fail`, props<{ error: any }>());

// lookups
export const loadSBUs = createAction(`${prefix} load SBUs`);
export const loadSBUsSuccess = createAction(`${prefix} load SBUs success`, props<{ sbus: SBU[] }>());
export const loadSBUsFail = createAction(`${prefix} load SBUs fail`, props<{ error: any }>());

// lookups
export const loadSubSBUs = createAction(`${prefix} load SubSBUs`);
export const loadSubSBUsSuccess = createAction(`${prefix} load SUbSBUs success`, props<{ subSBUs: SubSBU[] }>());
export const loadSubSBUsFail = createAction(`${prefix} load SubSBUs fail`, props<{ error: any }>());

//lookups
export const loadSellables = createAction(`${prefix} load sellables`);
export const loadSellablesSuccess = createAction(`${prefix} load sellables success`, props<{ sellables: SellableStatus[] }>());
export const loadSellablesFail = createAction(`${prefix} load sellables fail`, props<{ error: any }>());

// lookups
export const loadEquipmentTypes = createAction(`${prefix} load equipmentTypes`);
export const loadEquipmentTypesSuccess = createAction(`${prefix} load equipmentTypes success`, props<{ equipmentTypes: SealingElementEquipmentType[] }>());
export const loadEquipmentTypesFail = createAction(`${prefix} load equipmentTypes fail`, props<{ error: any }>());

// pipe sizes
export const loadAnsiPipeSizes = createAction(`${prefix} load ansi pipesizes`);
export const loadAnsiPipeSizesSuccess = createAction(`${prefix} load ansi pipesizes success`, props<{ data: any }>());
export const loadAnsiPipeSizesFail = createAction(`${prefix} load ansi pipesizes fail`, props<{ error: any }>());

// load plugging heads
export const loadPluggingHeads = createAction(`${prefix} load plugging heads`);
export const loadPluggingHeadsSuccess = createAction(`${prefix} load plugging heads success`, props<{ objs: SealingElementPluggingHead[] }>());
export const loadPluggingHeadsFail = createAction(`${prefix} load plugging heads fail`, props<{ error: any }>());

